import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    StoreType,
    OkrObjectiveFilters,
} from "client/store"
import {
    SearchBar,
    SearchFilter,
    FormGroup,
    Label,
    Input,
    SelectDropdown,
    SelectDropdownItem,
    Empty,
    Button,
    UserIcon,
} from "client/components"

interface SearchOkrObjectiveForm {
    filters: OkrObjectiveFilters
    onFilter: (filters: OkrObjectiveFilters) => void
}
interface SearchOkrObjective extends SearchOkrObjectiveForm {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
}

// TODO: add additional rows
const OkrObjectiveSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchOkrObjective) => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const extendedFilters: SearchFilter[] = []

    if (filters.title && filters.title.length) {
        extendedFilters.push({
            title: `${lang.title}: ${filters.title}`,
            onClose: (obj: OkrObjectiveFilters) => ({
                ...obj,
                title: null,
            }),
        })
    }
    if (filters.objectiveOwner) {
        const user = userList[filters.objectiveOwner]
        extendedFilters.push({
            title: `${lang.objectiveOwner}: ${user.firstName} ${user.lastName}`,
            onClose: (obj: OkrObjectiveFilters) => ({
                ...obj,
                objectiveOwner: null,
            }),
        })
    }
    if (filters.keyResultOwner) {
        const user = userList[filters.keyResultOwner]
        extendedFilters.push({
            title: `${lang.keyResultOwner}: ${user.firstName} ${user.lastName}`,
            onClose: (obj: OkrObjectiveFilters) => ({
                ...obj,
                keyResultOwner: null,
            }),
        })
    }

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            extendedFilters={extendedFilters}
            filterForm={<OkrObjectiveFilterForm filters={filters} onFilter={onFilter} />}
            onFilter={onFilter}
        />
    )
}
export default OkrObjectiveSearch


const OkrObjectiveFilterForm = ({
    filters,
    onFilter,
}: SearchOkrObjectiveForm) => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountUserList = useSelector((state: StoreType) => state.accountUser.accountUserList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [title, setTitle] = useState(filters.title || "")
    const [objectiveOwner, setObjectiveOwner] = useState(filters.objectiveOwner)
    const [keyResultOwner, setKeyResultOwner] = useState(filters.keyResultOwner)

    useEffect(() => {
        setTitle(filters.title || "")
        setObjectiveOwner(filters.objectiveOwner)
        setKeyResultOwner(filters.keyResultOwner)
    }, [filters])

    const onSearch = () => {
        const newFilters: OkrObjectiveFilters = {
            ...filters,
            title,
            objectiveOwner,
            keyResultOwner,
        }
        onFilter(newFilters)
    }

    const accountUsers = (accountUserList && accountUserList[userData.accountId]) || []

    return (
        <Row>
            <Col xs={12}>
                <FormGroup>
                    <Label>{lang.title}</Label>
                    <Input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
                </FormGroup>

                <FormGroup>
                    <Label>{lang.objectiveOwner}</Label>
                    <SelectDropdown title={
                        objectiveOwner
                            ? <UserIcon user={userList[objectiveOwner]} size="sm" />
                            : <Empty />
                    }
                    >
                        <SelectDropdownItem onClick={() => setObjectiveOwner(null)}><Empty /></SelectDropdownItem>
                        {
                            accountUsers.map((id) => (
                                <SelectDropdownItem key={id} onClick={() => setObjectiveOwner(id)}>
                                    <UserIcon user={userList[id]} size="sm" />
                                </SelectDropdownItem>
                            ))
                        }
                    </SelectDropdown>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.keyResultOwner}</Label>
                    <SelectDropdown title={
                        keyResultOwner
                            ? <UserIcon user={userList[keyResultOwner]} size="sm" />
                            : <Empty />
                    }
                    >
                        <SelectDropdownItem onClick={() => setKeyResultOwner(null)}><Empty /></SelectDropdownItem>
                        {
                            accountUsers.map((id) => (
                                <SelectDropdownItem key={id} onClick={() => setKeyResultOwner(id)}>
                                    <UserIcon user={userList[id]} size="sm" />
                                </SelectDropdownItem>
                            ))
                        }
                    </SelectDropdown>
                </FormGroup>
            </Col>
            <Col xs={12}>
                <Button row onClick={onSearch}>{lang.search}</Button>
            </Col>
        </Row>
    )
}
